<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1" y="0.5" width="15" height="15" rx="3.5" fill="white"/>
<rect x="1" y="0.5" width="15" height="15" rx="3.5" stroke="#E0E0E0" />
</svg>
